'use strict';
module.exports = {
	stdout: false,
	stderr: false
};



// WEBPACK FOOTER //
// ./~/chalk/~/supports-color/browser.js